import { z } from 'zod'

const booleanSearchParam = z
  .preprocess((value) => value === true || value === 'true', z.boolean())
  .catch(false)

export const diarySortColumns = [
  'date',
  'programitem',
  'workplace',
  'time',
  'academichours',
  'duration',
  'grade',
  'commentintern',
  'commentedusupervisor',
  'commentsupervisor',
] as const

export const diaryWorkplaces = ['OnSite', 'Remote', 'Mixed', 'Dynamic'] as const

export const diarySearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .int()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(diarySortColumns).catch('date'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
  dateFrom: z.iso.date().optional().catch(undefined),
  dateTo: z.iso.date().optional().catch(undefined),
  programItemId: z.string().min(1).optional().catch(undefined),
  workplace: z.enum(diaryWorkplaces).optional().catch(undefined),
  graded: booleanSearchParam,
  ungraded: booleanSearchParam,
})

export type DiarySearch = z.infer<typeof diarySearchSchema>

export const defaultDiarySearch = diarySearchSchema.parse({})

export const diaryFilterCount = (search: DiarySearch) =>
  [
    search.dateFrom,
    search.dateTo,
    search.programItemId,
    search.workplace,
    search.graded,
    search.ungraded,
  ].filter(Boolean).length
